import React from 'react';

import parsePhoneNumber from 'libphonenumber-js';
import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import InputMask from '@components/InputMask';

import style from './VerifyCode.scss';

const cn = bemCssModules(style, 'VerifyCode');
const ti = getTestId('VerifyCode');

export type TVerifyCode = {
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  code: string;
  codeLength?: number | undefined;
  codeType: 'email' | 'phone' | '2fa';
  isLoading?: boolean;
  className?: string;
  targetValue: string;
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>['inputMode'];
  tooltip?: React.ReactNode;
  button?: React.ReactNode;
  onQuestionClick?(tooltipIsOpen: boolean): void;
  customInputClass?: string;
  error?: string | boolean;
  description?: string;
};

const VerifyCode: CustomFC<TVerifyCode> = props => {
  const {
    onChange,
    className,
    codeLength = 4,
    isLoading = false,
    inputMode = 'decimal',
    codeType = 'email',
    targetValue,
    customInputClass,
    error = '',
    tooltip,
    description,
    code,
    ...rest
  } = props;
  const { t } = useTranslation();

  const isPhone = codeType === 'phone';
  const formatValue = isPhone
    ? parsePhoneNumber(targetValue)?.formatInternational() || targetValue
    : targetValue;

  const maskOptions = { mask: new Array<RegExp>(codeLength).fill(/[\d*]/) };

  return (
    <div className={cn(null, [className])}>
      <div className={cn('text')}>
        {description || t(`public.enter_${codeType}_code`, { targetValue: formatValue })}
      </div>
      <InputMask
        className={cn('input', [customInputClass])}
        autoFocus
        value={code}
        isLoading={isLoading}
        onChange={onChange}
        placeholder={'0'.repeat(codeLength)}
        maskOptions={maskOptions}
        inputMode={inputMode}
        error={error}
        autoComplete="one-time-code"
        tooltipContent={tooltip}
        data-testid={ti('input')}
        {...rest}
      />
    </div>
  );
};

export default VerifyCode;
